import { ExportOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import * as XLSX from 'xlsx';

const buttonPropsDefault = {
  type: 'default',
  variant: 'default',
  size: 'large'
};

/**
 * A button component that exports given data to an Excel file.
 *
 * @param {array} jsonData - The data to be exported.
 * @param {string} fileName - The name of the file to be exported.
 * @param {object} buttonProps - Additional props for the Ant Design Button component.
 *
 * @returns {React.Component} A button component that triggers the export.
 */

export const ButtonExportData = ({ jsonData = [], fileName = 'Export', ...buttonProps }) => {
  const xport = () => {
    if (!jsonData.length) {
      console.warn('No data provided for export.');
      return;
    }

    // Convert JSON data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(jsonData);

    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Hoja1');

    // Write the workbook and trigger download
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  };

  const mergedButtonProps = { ...buttonPropsDefault, ...buttonProps };

  return (
    <Button {...mergedButtonProps} onClick={xport} size="middle">
      Exportar <ExportOutlined />
    </Button>
  );
};
